<template>
    <highcharts class="hc" :ref="refId" :options="options" style="max-height: 500px"></highcharts>
</template>

<script>
    // utils
    import {getKey} from "../../utils/common";
    // constants
    import {chartColors} from "../../constants/chart-constants";
    // external
    import Highcharts from 'highcharts';
    import More from 'highcharts/highcharts-more';
    import exportingData from 'highcharts/modules/export-data';
    // mixins
    import ChartOptionsMixin from "../../mixins/ChartOptionsMixin";

    More(Highcharts);
    exportingData(Highcharts);

    /**
     * Wrapper for highcharts component.
     * This is a polar area chart by its
     * nature. Has a custom formatter for the
     * labels, custom colors.
     */

    export default {
        name: "RoseWindChart",
        mixins: [ChartOptionsMixin],
        data() {
            return {
                chartColors,
                options: {
                    ...this.data,
                    chart: {
                        polar: true,
                        type: 'column'
                    },
                    exporting: this.getChartExportingOptions(),
                    resetZoomButton: {
                        theme: {
                            display: 'none'
                        }
                    },
                    title: {
                        text: null
                    },
                    pane: {
                        size: '95%'
                    },
                    legend: {
                        reversed: false,
                        align: 'right',
                        verticalAlign: 'top',
                        y: 100,
                        layout: 'vertical'
                    },
                    xAxis: {
                        tickmarkPlacement: 'on',
                        labels: {
                            style: {
                                color: "#000"
                            },
                            formatter: label => {
                                /** NOTE: the formatter function is called inside the chart component
                                 * thus it can supply the label as a param.
                                 * This ES6 function doesn't bind this, so the two are different.
                                 */
                                return this.categoriesLocalized[
                                    Highcharts.Axis.prototype.defaultLabelFormatter.call(label)];
                            }
                        }
                    },
                    yAxis: {
                        min: 0,
                        endOnTick: false,
                        showLastLabel: true,
                        reversedStacks: false,
                        tickInterval: 5
                    },
                    tooltip: {
                        valueSuffix: '%',
                        followPointer: true
                    },
                    credits: {
                        enabled: false
                    },
                    plotOptions: {
                        series: {
                            stacking: 'normal',
                            shadow: false,
                            groupPadding: 0,
                            pointPlacement: 'on'
                        },
                        column: {
                            colors: chartColors
                        }
                    }
                }
            }
        },
        props: {
            data: {
                type: Object,
                required: true
            }
        },
        created() {
            Highcharts.setOptions({
                lang: this.getChartTranslations()
            });
        },
        computed: {
            /**
             * Get a dynamic key for referencing the highcharts object.
             */
            refId() {
                return getKey();
            },
            categoriesLocalized() {
                return this.$i18n.t('directions.list');
            }
        }
    };
</script>
